import React from "react";
import { motion } from "framer-motion";
import { customiseProcess } from "../Data";

const CustomiseProcess = ({heading}) => {
    return(
        <>
        <section className="process-section">

  <div className="container">

    {/* SUBHEADING */}
    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      OUR PROCESS
    </motion.h3>

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.15,
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{ once: true }}
    >
      {heading}
    </motion.h2>

    {/* PROCESS GRID */}
    <motion.div
      className="process-grid"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.16,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
    >

      {customiseProcess.map((item, i) => (

        <motion.div
          className="process-card"
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              y: 70,
              scale: 0.92,
            },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
            },
          }}
          transition={{
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1],
          }}
          whileHover={{
            y: -10,
          }}
        >

          {/* NUMBER */}
          <motion.p
            className="process-number"
            initial={{
              opacity: 0,
              scale: 0.5,
              rotate: -12,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
              rotate: 0,
            }}
            transition={{
              delay: 0.2 + i * 0.1,
              type: "spring",
              stiffness: 180,
              damping: 12,
            }}
            viewport={{ once: true }}
          >
            {item.number}
          </motion.p>

          {/* TITLE */}
          <motion.h4
            className="card-heading"
            initial={{
              opacity: 0,
              y: 20,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 0.35 + i * 0.1,
              duration: 0.5,
            }}
            viewport={{ once: true }}
          >
            {item.title}
          </motion.h4>

        </motion.div>

      ))}

    </motion.div>

  </div>

</section>
        </>
    )
}
export default CustomiseProcess;